import axios from 'axios';

const service = axios.create({
  baseURL: getVideoURL(),
  proxy: true,
  timeout: 6000,
  withCredentials: true
});

service.interceptors.response.use(
  response => response,
  error => {
    console.log('err' + error);
    return Promise.reject(error)
  });

export default service



// WEBPACK FOOTER //
// ./src/common/video-request.js